import { render } from "./IconCart.vue?vue&type=template&id=4d764e7a"
import script from "./IconCart.vue?vue&type=script&lang=js"
export * from "./IconCart.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__